import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import AuthActions from 'Redux/AuthRedux'
import { Button, Form, Container, Segment, Loader, Header, Icon } from 'semantic-ui-react'
import Alert from 'Components/Alert'
import { path } from 'ramda'

import Profile from 'Components/Profile'
import AvatarUpload from 'Components/AvatarUpload'

class Settings extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      jwApiKey: path(['settings', 'jwApiKey'], props.userData),
      jwApiSecret: path(['settings', 'jwApiSecret'], props.userData),
      showJwApiSecret: false
    }
  }

  onSaveSettings = () => {
    this.props.profileUpdateRequest({
      settings: {
        jwApiKey: this.state.jwApiKey,
        jwApiSecret: this.state.jwApiSecret
      }
    })
  }

  toggleJwApiSecret = () => {
    this.setState({showJwApiSecret: !this.state.showJwApiSecret})
  }

  onChange = event => {
    const { name, value } = event.target
    this.setState({[name]: value})
  }

  render () {
    return (
      <Container style={{marginTop: '20px'}}>
        <Profile />
        <AvatarUpload />
        <Segment>
          <Alert color='red' messages={this.props.error} />
          <Form>
            <Header as='h2'>
            <Icon name='upload' color='grey' />
            <Header.Content>
              <a href='https://dashboard.jwplayer.com/#/account/apicredentials'
                 rel='noopener noreferrer'
                 target="_blank">
                JW Platform Integration
                <Header.Subheader>
                  Push videos directly to JW platform
                </Header.Subheader>
              </a>
            </Header.Content>
          </Header>
            <Loader active={this.props.fetching} />
            <Form.Field>
              <label>JW API Key</label>
              <input
                type='text'
                name='jwApiKey'
                placeholder='JW API Key'
                value={this.state.jwApiKey}
                onChange={this.onChange}
              />
            </Form.Field>
            <Form.Field>
              <label>JW API Secret</label>
                <Form.Input iconPosition='left' name="email" >
                <Icon
                  name={ this.state.showJwApiSecret ? 'eye': 'eye slash' }
                  link
                  onClick={this.toggleJwApiSecret} />
                <input
                  type={this.state.showJwApiSecret ? 'text' : 'password'}
                  name='jwApiSecret'
                  placeholder='JW API Secret'
                  value={this.state.jwApiSecret}
                  onChange={this.onChange}
                />
              </Form.Input>
            </Form.Field>
            <Button
              primary
              type='submit'
              onClick={this.onSaveSettings}>Submit</Button>
          </Form>
        </Segment>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  fetching: state.auth.updateFetching,
  error: state.auth.updateError
})

const mapDispatchToProps = (dispatch) => ({
  profileUpdateRequest: (params) =>
    dispatch(AuthActions.profileUpdateRequest(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/Pages/Settings.js